import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import registrationSlice from './registration.slice';
import authenticationSlice from './authentication.slice';
import userSlice from './user.slice';
import projectsSlice from './project.slice';
import commonSlice from './common.slice';
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';

const store = configureStore({
  reducer: {
    common: commonSlice.reducer,
    authentication: authenticationSlice.reducer,
    registration: registrationSlice.reducer,
    projects: projectsSlice.reducer,
    user: userSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => (import.meta.env.MODE === 'development')
  // @ts-ignore
    ? getDefaultMiddleware({ serializableCheck: false }).concat(logger)
    : getDefaultMiddleware({ serializableCheck: false })
});

export type RootState = ReturnType<typeof store.getState>;

type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export function reset() {
  store.dispatch(authenticationSlice.actions.reset());
  store.dispatch(registrationSlice.actions.reset());
  store.dispatch(projectsSlice.actions.reset());
  store.dispatch(userSlice.actions.reset());
  store.dispatch(commonSlice.actions.reset());
}

export default store;
